import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography, Box } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { getOee, type ProductionOrderListItem } from '../../api/productieOrdine'

function Metric({ label, value }: { label: string; value: number | null }) {
  return (
    <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 1, flex: 1, textAlign: 'center' }}>
      <Typography variant="h3">{value != null ? `${(value * 100).toFixed(1).replace('.', ',')}%` : '—'}</Typography>
      <Typography variant="body2" color="text.secondary">{label}</Typography>
    </Box>
  )
}

export default function OeeDialog({ target, onClose }: { target: ProductionOrderListItem | null; onClose: () => void }) {
  const open = target !== null
  const { data } = useQuery({ queryKey: ['productie', 'ordine', target?.id, 'oee'], queryFn: () => getOee(target!.id), enabled: open })

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>OEE — {target?.number}</DialogTitle>
      <DialogContent>
        <Stack direction="row" spacing={2} sx={{ mt: 0.5 }}>
          <Metric label="Calitate" value={data?.quality ?? null} />
          <Metric label="Disponibilitate" value={data?.availability ?? null} />
          <Metric label="Performanță" value={data?.performance ?? null} />
        </Stack>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 2 }}>
          Performanța necesită timpi standard compleți per operație (FR-OPE-010), neconstruiți încă — apare ca „—" intenționat, nu ca eroare.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose}>Închide</Button>
      </DialogActions>
    </Dialog>
  )
}
